import React, { PropTypes, Component } from 'react'
import DataRow from './dataRow'
import RadioSelect from './radioSelect'
import DataRowHeader from './dataRowHeader'
import styles from './styles'
import misc from 'utils/misc'

export default class DataTable extends Component {

  // schemas = [
  // {type: ooo, title: yyy, key: qoo, width: '3em'},
  // {type: ooo, title: yyy, key: xyz, width: '10em', map},
  // ...
  // ];
  static propTypes = {
    schemas: PropTypes.array.isRequired,
    dataArray: PropTypes.array.isRequired,
    radioSelectKey: PropTypes.string, // key string in schemas (only for dropDown)
    onDataUpdate: PropTypes.func,
  };

  constructor (props) {
    super(props)
    this.onFilterChange = e => this.setState({ filter: `${e.target.value}` })
    this.onRadioSelect = radioFilterKey => this.setState({ radioFilterKey })
    this.isPassingFilter = ::this.isPassingFilter
  }

  state = {
    filter: '',
    radioFilterKey: null,
  };

  componentWillReceiveProps (nextProps) {
    if (this.props.radioSelectKey !== nextProps.radioSelectKey ||
        !misc.isObjectEqual(this.props.schemas, nextProps.schemas)
       ) {
      this.setState({ filter: '', radioFilterIndex: -1 })
    }
  }

  static CellType = {
    text: 'text',
    input: 'input',
    password: 'password',
    autoComplete: 'autoComplete',
    dropDown: 'dropDown',
    date: 'date',
  };

  isPassingFilter (data) {
    const { filter, radioFilterKey } = this.state
    const { schemas } = this.props
    let isMatch = filter === ''
    if (!isMatch) {
      schemas.forEach(s => {
        if (s.key !== '_id') {
          if (s.type === DataTable.CellType.autoComplete ||
              s.type === DataTable.CellType.dropDown) {
            if (misc.isMatchFilterStr(s.map[data[s.key].toString()], filter)) {
              isMatch = true
            }
          } else {
            if (misc.isMatchFilterStr(data[s.key], filter)) {
              isMatch = true
            }
          }
        }
      })
    }

    if (isMatch) {
      const { radioSelectKey } = this.props
      return (
        radioFilterKey === null ||
        radioFilterKey === data[radioSelectKey].toString()
      )
    }

    return false
  }

  render () {
    const { schemas, dataArray, radioSelectKey, onDataUpdate } = this.props
    const filteredDataArray = dataArray.filter(this.isPassingFilter)

    let tableWidth = 0.5
    schemas.forEach(schema => {
      tableWidth += parseFloat(schema.width.split('em')[0])
    })

    let radioSelect = null
    if (radioSelectKey) {
      const radioSchema = schemas.filter(schema => schema.key === radioSelectKey)[0]
      radioSelect = (
        <RadioSelect
          title={radioSchema.title}
          map={radioSchema.map}
          selectedKey={this.state.radioFilterKey}
          onSelect={this.onRadioSelect}
        />
      )
    }

    return (
      <div className={styles.dataTable} style={{ width: `${tableWidth}em` }} >
        <input
          className={styles.filterInput}
          value={this.state.value}
          onChange={this.onFilterChange}
          placeholder="輸入搜尋字串"
        />
        {radioSelect}
        <DataRowHeader schemas={schemas} />
        {filteredDataArray.map(data =>
          <DataRow {...{ key: data._id, schemas, data, onDataUpdate }} />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataTable/index.jsx